import { Button, Checkbox } from 'avo-ui'
import icDownloadWhite from 'assets/images/ic-download-white.svg'
import icUpload from 'assets/images/ic-upload.svg'
import icDragDrop from 'assets/images/ic-drag-drop.svg'
import icXCircle from 'assets/images/ic-x-circle.svg'

export const UploadXLSXFile = ({
    uploadFileRef,
    isUpdate,
    isDragOver,
    isLoading,
    sourceFile,
    onClickDownload,
    cancelUploadFile,
    onChangeUploadFile,
    onDragAndDrop,
    onChangeUpdate,
    onSubmitFile,
}) => {
    return (
        <div className={'w-5/6 flex flex-col space-y-4 text-neutral-80 border rounded-lg'}>
            <div className={'flex flex-row justify-between p-6 items-center'}>
                <div className={'space-y-2'}>
                    <p className={'text-lg text-blue-90'}>Import Product From XLSX File</p>
                    <p>This tools allows you to import (or merge) Product data to Product list from a XLSX file.</p>
                </div>
                <Button
                    className={'px-8'}
                    title={'Download Template'}
                    icon={icDownloadWhite}
                    onClick={onClickDownload}
                    loading={isLoading}
                />
            </div>
            <div className={'grid grid-cols-2 text-blue-90 bg-blue-2'}>
                <div className={'flex flex-col p-6 space-y-4 border-y'}>
                    <p className={'font-bold text-blue-90'}>Choose XLSX File</p>
                    <div className={'flex flex-row items-center space-x-4'}>
                        <div className={'relative'}>
                            <div
                                className={'avo__button bg-blue-5 border border-blue-20 hover:bg-blue-20 space-x-3'}
                                onClick={() => uploadFileRef.current.click()}
                            >
                                <img src={icUpload} className={'w-4'} alt={'ic-upload'} />
                                <div className={'font-semibold'}>Browse</div>
                            </div>
                            <input
                                type={'file'}
                                accept={'.xlsx'}
                                className={'absolute top-0 hidden'}
                                ref={uploadFileRef}
                                onChange={onChangeUploadFile}
                            />
                        </div>
                        <p className={'font-semibold'}>Maximum Size 64 mb</p>
                    </div>
                </div>
                <div className={'border-y border-l px-8 py-6'}>
                    <div
                        onDrop={(e) => onDragAndDrop(e)}
                        onDragOver={(e) => onDragAndDrop(e)}
                        onDragLeave={(e) => onDragAndDrop(e)}
                        className={'flex px-8 py-6 justify-center border border-dashed border-neutral-40 rounded-lg'}
                    >
                        <div className={'flex space-x-4 items-center'}>
                            <img
                                src={icDragDrop}
                                alt='ic-document-upload'
                                className={`mx-auto ${isDragOver && 'animate-bounce'}`}
                            />
                            <div className={'col space-y-2'}>
                                <p>Drag File Here</p>
                                <p className={'italic'}>XLSX File Format</p>
                            </div>
                        </div>
                    </div>
                </div>
                {sourceFile?.name && (
                    <div className={'flex items-center space-x-12 p-6'}>
                        <p>File Imported :</p>
                        <div className={'flex items-center space-x-4 py-2 px-4 border bg-white rounded-lg'}>
                            <p className={'text-forged-stee w-40 truncate'}>{sourceFile?.name}</p>
                            <img
                                src={icXCircle}
                                alt={'delete-source'}
                                className={'cursor-pointer'}
                                onClick={() => cancelUploadFile()}
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className={'flex p-6 justify-between items-center border-b'}>
                <p className={'font-medium text-blue-90'}>Update Existing Products</p>
                <Checkbox
                    name={'isUpdate'}
                    checked={isUpdate}
                    label={
                        <div>
                            <p>Existing products thet match by ID or SKU will be Updated.</p>
                            <p>Products that do not exist will be skipped.</p>
                        </div>
                    }
                    onChange={onChangeUpdate}
                />
            </div>
            <div className={'flex pb-4 justify-center'}>
                <Button className={'px-12'} title={'Next'} disabled={!sourceFile?.name} onClick={onSubmitFile} />
            </div>
        </div>
    )
}
